import React, { useEffect, useImperativeHandle, useRef, useState } from "react";
import { isEmpty } from "lodash";
import { Alert, Box, Typography } from "@curves/ui-base";
import { TimeLine } from "@curves/ui-shared";
import { ActivityRecordCard } from "@shared/components";
import { adaptCycleOrderChange, TimelineRecordItem } from "@icoach/memberDetail/components/memberChangeRecord";
import useMemberCyclePurchaseApi from "@apis/useMemberCyclePurchaseApi";
import useForkRef from "@util/hook/useForkRef";

const CycleOrderRecordList = React.forwardRef(({ sourceData }, ref) => {
	const { memberID, cycleOrderID } = sourceData || {};
	const handleRef = useRef(null);
	const selfRef = useForkRef(handleRef, ref);
	const { getMemberCycleOrderHistoryApi } = useMemberCyclePurchaseApi();
	const [record, setRecord] = useState([]);

	const doMemberCycleOrderHistoryApi = async (memberID, cycleOrderID) => {
		let res = await getMemberCycleOrderHistoryApi(memberID, cycleOrderID);
		if (res) {
			setRecord(res);
			return res;
		}
	};

	useEffect(() => {
		if (memberID && cycleOrderID) {
			doMemberCycleOrderHistoryApi(memberID, cycleOrderID);
		}
		// eslint-disable-next-line
	}, [memberID, cycleOrderID]);

	useImperativeHandle(
		selfRef,
		() => ({
			doMemberCycleOrderHistoryApi,
		}),
		// eslint-disable-next-line
		[],
	);

	if (isEmpty(record))
		return (
			<Alert className={"mb-4"} color="info" severity="info" variant="filled">
				尚無資料
			</Alert>
		);

	return (
		<TimeLine as="ul" className="membership-record mb-4">
			{record.map((item, i) => {
				const itemData = adaptCycleOrderChange(item);
				return (
					<TimeLine.Item key={itemData.id} as="li">
						<TimelineRecordItem metainfo={itemData.timelineMetainfo}>
							<ActivityRecordCard status={itemData.type}>
								{itemData.pdfUrl && <ActivityRecordCard.PdfAttachment pdfUrl={itemData.pdfUrl} />}
							<ActivityRecordCard.Content style={isEmpty(itemData.descList) ? { display: "flex", alignItems: "center" } : undefined}>
									<Box className="activity-record-card__main">
										<Typography variant="h6" className="title">
											{itemData.title}
										</Typography>
										{!isEmpty(itemData.descList) &&
											itemData.descList.map((desc, descIndex) => (
												<Typography key={descIndex} variant="body2" className="mb-1">
													{desc.label ? `${desc.label}：${desc.text}` : desc.text}
												</Typography>
											))}
									</Box>
							</ActivityRecordCard.Content>
							</ActivityRecordCard>
						</TimelineRecordItem>
					</TimeLine.Item>
				);
			})}
		</TimeLine>
	);
});

export default CycleOrderRecordList;
